import { mainStore } from "../stores/MainStore";

export const useTicketStore = () => {
  return mainStore.ticketStore;
};
